export class BusinessException extends Error {
    public code: string;
    public level: number;
    public message: string;

    constructor(code: string) {
        super();
        this.code = code;
    };

}